import _ from "lodash";
import { colors, colorPalette } from "./colorConstants";
import MimeDb from "./mimeTypeConstants";
import EventEmitter from "eventemitter3";
import {
  DiagnosticAssessmentColored,
  BenchmarkAssessmentColored,
  FormativeAssessmentColored,
  OngoingAssessmentColored,
  PriorAssessmentColored,
  SummativeAssessmentColored,
  LearningExperienceColored,
  PerformanceTasksColored,
  SupplementaryEvidenceColored,
  GeneralAssessmentColored,
  FaOutlined,
  SaOutlined,
  LeOutlined,
  QuickTaskOutlined,
  AddOutlined,
  UploadOutlined,
  MicrophoneOutlined,
  AddCircleOutlined,
  GoogleDriveColored,
  DeviceDesktopOutlined,
  WorkbookColored,
  OneDriveColored,
  WorksheetClipboardOutlined,
  WorksheetColored,
  AiOutlined,
  LinkColored,
  LinkOutlined,
  WorkbookOutlined,
  PageFoldPortraitOutlined,
  CodeOutlined,
} from "@toddle-edu/ds-icons";
import {
  PlaceholderOneRectangleIllustration,
  PlaceholderTwoRectangleIllustration,
  PlaceholderThreeRectangleIllustration,
  PlaceholderFourRectangleIllustration,
  PlaceholderFiveRectangleIllustration,
  PlaceholderSixRectangleIllustration,
  PlaceholderSevenRectangleIllustration,
  PlaceholderEightRectangleIllustration,
  PlaceholderOneIllustration,
  PlaceholderTwoIllustration,
  PlaceholderThreeIllustration,
  PlaceholderFourIllustration,
  PlaceholderFiveIllustration,
  PlaceholderSixIllustration,
  PlaceholderSevenIllustration,
  PlaceholderEightIllustration,
} from "@toddle-edu/ds-theme";
import {
  QuickTaskFilledIcon,
  LEFilledIcon,
  Formative,
  Summative,
} from "SvgComponents";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_PYP,
  PLAN_TYPE_360,
  PLAN_TYPE_360_PILOT,
  PLAN_TYPE_ULTIMATE,
  PLAN_TYPE_ULTIMATE_PILOT,
  PLAN_TYPE_FREE,
  PLAN_TYPE_PRO,
  PLAN_TYPE_PRO_PILOT,
  PLAN_TYPE_DEMO,
  MICROSOFT_SERVICE_TYPE,
  GOOGLE_SERVICE_TYPE,
  STUDENT_TEMPLATE_OPTION_NONE,
  CURRICULUM_PLAN_TYPE_FREEMIUM,
  CURRICULUM_PLAN_TYPE_PRO_AI,
  CURRICULUM_PLAN_TYPE_ESSENTIALS,
  CURRICULUM_PLAN_TYPE_ULTIMATE,
  CURRICULUM_PLAN_TYPE_PRO,
  CURRICULUM_PLAN_NA,
} from "./stringConstants";
import {
  workbookUrl,
  websiteUrl,
  portalUrlCN,
  microsoftClientId,
  zoomClientId,
  lexClientId,
  lexPilotClientId,
  cleverClientId,
  classLinkClientId,
  configMyp,
  configUbd,
  configMb,
  demoMypOrg,
  getIsChina,
  vitallyNps,
  lexSsoUrl,
  lexPilotSsoUrl,
} from "config";

export { intercomUSAppId, intercomAUSAppId } from "config";
export const intercomApiBaseForIntercomUS = "https://api-iam.intercom.io";
export const intercomApiBaseForIntercomAUS = "https://api-iam.au.intercom.io";

export {
  inputHTMLAttributes,
  textareaHTMLAttributes,
} from "./htmlInputHelpers";

export const PLACEHOLDER_SQUARE_IMAGE = [
  PlaceholderOneIllustration,
  PlaceholderTwoIllustration,
  PlaceholderThreeIllustration,
  PlaceholderFourIllustration,
  PlaceholderFiveIllustration,
  PlaceholderSixIllustration,
  PlaceholderSevenIllustration,
  PlaceholderEightIllustration,
];

export const PLACEHOLDER_SQUARE_IMAGE_COUNT = _.size(PLACEHOLDER_SQUARE_IMAGE);

export const PLACEHOLDER_RECT_IMAGE = [
  PlaceholderOneRectangleIllustration,
  PlaceholderTwoRectangleIllustration,
  PlaceholderThreeRectangleIllustration,
  PlaceholderFourRectangleIllustration,
  PlaceholderFiveRectangleIllustration,
  PlaceholderSixRectangleIllustration,
  PlaceholderSevenRectangleIllustration,
  PlaceholderEightRectangleIllustration,
];

export const PLACEHOLDER_RECT_IMAGE_COUNT = _.size(PLACEHOLDER_RECT_IMAGE);

export { fontStyles as fontStyle } from "@toddle-edu/ds-theme";
export { colors, colorPalette, MimeDb };

export const getCloudUrl = () => {
  if (getIsChina()) {
    return "https://cloud.toddleapp.cn";
  } else return "https://cloud.toddleapp.com";
};

/**
 * Deprecated, DO NOT USE
 * @type {string}
 */
export const CLOUD_URL = getCloudUrl();
const isChina = getIsChina();

export const PRIVACY_URL = isChina
  ? "https://www.toddleapp.cn/privacy-policy"
  : "https://www.toddleapp.com/privacy-policy";
export const TERM_OF_SERVICE_URL = "https://www.toddleapp.com/termsofservice";
export const TERM_OF_USE_URL = "https://www.toddleapp.com/termsofuse";
export const COOKIE_URL = "https://www.toddleapp.com/cookie-policy/";

export const SUPPORT_URL = isChina
  ? "https://support.toddleapp.cn"
  : "https://support.toddleapp.com";
export const WEBSITE_URL = websiteUrl;
export const PORTAL_URL_CN = portalUrlCN;
export const PORTAL_URL_GLOBAL = "https://web.toddleapp.com";
export const SCHEDULE_MEETING_URL_FREE_DEMO =
  "https://meetings.hubspot.com/toddle/demo-call";
export const VITALLY_NPS = vitallyNps;
export const PusherEvent = new EventEmitter();
export const PresenceEvent = new EventEmitter();
export const BlurFieldEvent = new EventEmitter();
export const AudioPlayerEvent = new EventEmitter();
export const MessengerEvent = new EventEmitter();
export const DragDropEvent = new EventEmitter();

export const LEX = "LEX";

export const LEX_PILOT = "LEX_PILOT";

export const FONT_URL =
  "https://fast.fonts.net/jsapi/8d436f36-1b8b-45c4-b990-c8c5d2f12edd.js";
export const GOOGLE_CLIENT_ID =
  "328967318361-jutd87l49b97g76d2kareu14tqtjp00d.apps.googleusercontent.com";
export const GOOGLE_DEVELOPER_KEY = "AIzaSyDZ23YQu6gpqLi-za6VtmsvtxExhaVkrqU";
export const GOOGLE_APP_ID = "328967318361";

export const MICROSOFT_CLIENT_ID = microsoftClientId;

export const ZOOM_CLIENT_ID = zoomClientId;

export const CLEVER_CLIENT_ID = cleverClientId;

export const LEX_CLIENT_ID = lexClientId;

export const LEX_PILOT_CLIENT_ID = lexPilotClientId;

export const CLASSLINK_CLIENT_ID = classLinkClientId;

export const LEX_CODE_CHALLENGE = `g5R5mtyNrXaeA2RkInoLuaFMhy-umzEV8nVY8MBUHbs`;

export const WORK_BOOK_URL = workbookUrl;

export const mypConfig = configMyp;

export const ubdConfig = configUbd;

export const mbConfig = configMb;

export const redirectUri = encodeURI(window.location.origin);

export const ZOOM_AUTH_URL = `https://zoom.us/oauth/authorize?client_id=${ZOOM_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}`;

export const LEX_SSO_URL = codeChallenge => {
  return getLexSsoUrl(
    LEX_CLIENT_ID,
    redirectUri,
    codeChallenge ? codeChallenge : LEX_CODE_CHALLENGE
  );
};

const getLexSsoUrl = (LEX_CLIENT_ID, redirectUri, LEX_CODE_CHALLENGE) => {
  return `${lexSsoUrl}/sso/connect/authorize?client_id=${LEX_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}&scope=openid&code_challenge=${LEX_CODE_CHALLENGE}&code_challenge_method=S256`;
};

const getLexPilotSsoUrl = (LEX_CLIENT_ID, redirectUri, LEX_CODE_CHALLENGE) => {
  return `${lexPilotSsoUrl}/sso/connect/authorize?client_id=${LEX_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}&scope=openid&code_challenge=${LEX_CODE_CHALLENGE}&code_challenge_method=S256`;
};

export const LEX_PILOT_SSO_URL = codeChallenge => {
  return getLexPilotSsoUrl(
    LEX_PILOT_CLIENT_ID,
    encodeURI(window.location.href),
    codeChallenge ? codeChallenge : LEX_CODE_CHALLENGE
  );
};

export const LEX_TODDLE_PILOT_SSO_URL = codeChallenge => {
  return getLexPilotSsoUrl(
    LEX_PILOT_CLIENT_ID,
    redirectUri,
    codeChallenge ? codeChallenge : LEX_CODE_CHALLENGE
  );
};

const getClassLinkSsoUrl = (CLASSLINK_CLIENT_ID, redirectUri) => {
  return `https://launchpad.classlink.com/oauth2/v2/auth?client_id=${CLASSLINK_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}&scope=profile`;
};

export const CLASSLINK_SSO_URL = getClassLinkSsoUrl(
  CLASSLINK_CLIENT_ID,
  redirectUri
);

export const MICROSOFT_SCOPES = ["user.read"];

export const GOOGLE_ANALYTICS_ID = "UA-84152542-3";
export const DEFAULT_PROFILE_PIC = `${getCloudUrl()}/assets/webapp/profile_image.png`;

export const MAX_FILE_SIZE_VIEWER_LIMIT = 26214400;
export const GOOGLE_FILE_VIEWER_URL = "https://docs.google.com/viewer?url=";
export const MS_FILE_VIEWER_URL =
  "https://view.officeapps.live.com/op/embed.aspx?src=";
export const MISC_FILE_EXTENSION_MIMETYPE_MAPPING = {
  key: "application/x-iwork-keynote-sffkey",
  numbers: "application/x-iwork-numbers-sffnumbers",
  pages: "application/x-iwork-pages-sffpages",
  csv: "text/csv",
};
export const MS_FILE_VIEWER_SUPPORTED_MIMETYPE = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/pdf",
];

export const GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE = [
  "application/vnd.google-apps.document",
  "application/vnd.google-apps.file",
  "application/vnd.google-apps.presentation",
  "application/vnd.google-apps.spreadsheet",
];
export const GOOGLE_PICKER_MIME_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  ...GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.google-apps.drawing",
];

export const MICROSOFT_TEMPLATE_SUPPORTED_MIMETYPE = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const APPLE_OFFICE_SUPPORTED_MIMETYPES = [
  "application/vnd.apple.keynote",
  "application/vnd.apple.numbers",
  "application/vnd.apple.pages",
  "application/x-iwork-keynote-sffkey",
];

export const PR_COMMENT_TEMPLATES_EMPTY = `${getCloudUrl()}/assets/webapp/PRCommentTemplateEmpty.png`;

export const SETUP_TURNITIN_API_KEY_HELP_CENTER_URL = `${SUPPORT_URL}/en/articles/8612021-how-do-i-integrate-and-configure-turnitin-for-my-school-as-an-admin`;
export const TRANSCRIPT_SETUP_URL = `https://vimeo.com/867069320/be22da1a7d`;
export const TRANSCRIPT_SETUP_VIDEO_THUMBNAIL = `${getCloudUrl()}/eu-west-1/s/NPm2zL/content/qTvs5R1h1/Screenshot2023-08-02at12.48.05PM.png`;

export const AI_GRADING_HELP_CENTER_URL = `${SUPPORT_URL}/en/articles/11959760-best-practices-for-ai-evaluations`;

export const POST_MEDIA_TYPES = {
  IMAGE: "photo",
  MULTI_IMAGE: "album",
  LINK: "link",
  FILE: "file",
  NOTE: "note",
  VIDEO: "video",
  AUDIO: "audio",
  WORKBOOK: "workbook",
};

export const PICKER_DIRECT_DOWNLOADABLE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/pdf",
  "video/mp4",
  "video/avi",
  "video/wmv",
  "audio/mp3",
  "audio/mpeg",
  "audio/m4a",
  "audio/vnd.wav",
  "audio/wav",
  "audio/x-wav",
  "audio/wave",
];

export const ALLOWED_PLAYABLE_VIDEO_FILE_TYPE = [
  "video/quicktime",
  "video/x-matroska",
];

export const ASSESSMENT_TYPE_PARENT_GROUP_MAPPING = {
  THIRD_STAGE_ASSESSMENT: ["fmt", "pri"],
  SECOND_STAGE_ASSESSMENT: ["pt", "se"],
};

export const ROASTER_OPTIONS = [
  {
    label: "Manual and upload",
    value: "MANUALANDUPLOAD",
  },
  {
    label: "Sync with Wonde",
    value: "WONDE",
  },
  {
    label: "Sync with Veracross",
    value: "VERACROSS",
  },
  {
    label: "Sync with iSAMS",
    value: "ISAMS",
  },
  {
    label: "Sync with Power School",
    value: "POWERSCHOOL",
  },
  {
    label: "Sync with Engage",
    value: "ENGAGE",
  },
  {
    label: "Sync with Clever",
    value: "CLEVER",
  },
  {
    label: "Sync with Google sheets",
    value: "SHEET",
  },
];

export const DRIVE_OPTIONS = [
  {
    label: "None",
    value: STUDENT_TEMPLATE_OPTION_NONE,
  },
  {
    label: "Google",
    value: GOOGLE_SERVICE_TYPE,
  },
  {
    label: "Microsoft",
    value: MICROSOFT_SERVICE_TYPE,
  },
];

/**
 * @deprecated
 * This is deprecated. Do not use this anywhere directly
 * Use "getCurrentAssessmentTypes" redux thunk from PlatformModule
 */
export const LE_ASSESSMENT_TYPE_MAPPING = {
  dig: {
    color: colors.yellow200,
    label: "Diagnostic Assessment",
    localeLabel: "common:diagnostic_assessment",
    pluralLocaleLabel: "common:diagnostic_assessments",
    abbrevation: "Da",
    shortLabel: "common:diagnostic_assessment_short",
    bgColor: colors.blue400,
    icon: DiagnosticAssessmentColored,
  },
  fmt: {
    color: colors.blueTwo,
    label: "Formative Assessment",
    localeLabel: "common:formative_assessment",
    pluralLocaleLabel: "common:formative_assessments",
    abbrevation: "Fa",
    shortLabel: "common:formative_assessment_short",
    bgColor: colors.violet500,
    icon: FormativeAssessmentColored,
    filledIcon: Formative,
    filledIconColor: colors.yellow500,
    outlinedIcon: FaOutlined,
    decorativeBGColor: colors.decorativeSurfaceThreeL,
    avatarIconColor: "yellow",
  },
  smt: {
    color: colors.blue400,
    label: "Summative assessment",
    localeLabel: "common:summative_assessment",
    pluralLocaleLabel: "common:summative_assessments",
    abbrevation: "Sa",
    shortLabel: "common:summative_assessment_short",
    bgColor: colors.teal200,
    icon: SummativeAssessmentColored,
    filledIcon: Summative,
    filledIconColor: colors.teal500,
    outlinedIcon: SaOutlined,
    decorativeBGColor: colors.decorativeSurfaceFiveL,
    avatarIconColor: "teal",
  },
  asmt: {
    color: colors.blue400,
    label: "Assessment",
    localeLabel: "common:assessment_label",
    bgColor: colors.teal200,
  },
  pri: {
    color: colors.yellow200,
    label: "Prior Assessment",
    localeLabel: "classRoom:pre_assessment",
    pluralLocaleLabel: "classRoom:pre_assessment",
    abbrevation: "Pa",
    shortLabel: "common:prior_assessment_short",
    bgColor: colors.blue400,
    icon: PriorAssessmentColored,
  },
  ong: {
    color: colors.blueTwo,
    label: "Ongoing Assessment",
    localeLabel: "common:ongoing_assessment",
    pluralLocaleLabel: "common:ongoing_assessments",
    abbrevation: "Oa",
    shortLabel: "common:ongoing_assessment_short",
    bgColor: colors.teal200,
    icon: OngoingAssessmentColored,
  },
  le: {
    color: colors.yellow400,
    label: "Learning experience",
    localeLabel: "common:le_label",
    pluralLocaleLabel: "common:le_label_plural",
    abbrevation: "",
    icon: LearningExperienceColored,
    filledIcon: LEFilledIcon,
    filledIconColor: colors.violet500,
    outlinedIcon: LeOutlined,
    decorativeBGColor: colors.decorativeSurfaceTwoL,
    avatarIconColor: "violet",
  },
  qt: {
    color: colors.yellow400,
    label: "Quick Task",
    localeLabel: "common:quick_task",
    pluralLocaleLabel: "common:quick_tasks",
    abbrevation: "Qt",
    icon: GeneralAssessmentColored,
    filledIcon: QuickTaskFilledIcon,
    filledIconColor: colors.blue500,
    outlinedIcon: QuickTaskOutlined,
    decorativeBGColor: colors.decorativeSurfaceOneL,
    avatarIconColor: "blue",
  },
  se: {
    color: colors.yellow200,
    label: "Supplementary Evidence",
    localeLabel: "common:supplementary_evidence",
    pluralLocaleLabel: "common:supplementary_evidences",
    bgColor: colors.blue400,
    icon: SupplementaryEvidenceColored,
  },
  pt: {
    color: colors.yellow200,
    label: "Performance Task(s)",
    localeLabel: "common:performance_task",
    pluralLocaleLabel: "common:performance_task",
    bgColor: colors.blue400,
    icon: PerformanceTasksColored,
  },
  ba: {
    color: colors.yellow200,
    label: "Benchmark Assessment",
    localeLabel: "common:benchmark_assessment",
    pluralLocaleLabel: "common:benchmark_assessments",
    bgColor: colors.blue400,
    icon: BenchmarkAssessmentColored,
  },
  afl: {
    color: colors.yellow200,
    label: "Assessment For Learning",
    localeLabel: "common:assessment_for_learning",
    bgColor: colors.blue400,
  },
  aol: {
    color: colors.yellow200,
    label: "Assessment Of Learning",
    localeLabel: "common:assessment_of_learning",
    bgColor: colors.blue400,
  },
  dp_pa: {
    color: colors.blueTwo,
    label: "Practical Activities",
    localeLabel: "common:practical_activities",
    abbrevation: "Pa",
    shortLabel: "common:practical_activities",
    avatarIconColor: "yellow",
  },
  dp_ep: {
    color: colors.blueTwo,
    label: "Experimental Programmes",
    localeLabel: "common:practical_activities",
    abbrevation: "Ep",
    shortLabel: "common:practical_activities",
    avatarIconColor: "yellow",
  },
  worksheet: {
    color: colors.blueTwo,
    label: "Worksheet",
    localeLabel: "common:worksheet",
    abbrevation: "Ws",
    shortLabel: "common:worksheet",
    avatarIconColor: "pink",
    icon: WorksheetColored,
  },
  ai_tutor: {
    color: colors.purple400,
    label: "AI tutor",
    localeLabel: "common:ai_tutor",
    abbrevation: "AI",
    shortLabel: "common:ai_tutor",
    avatarIconColor: "purple",
    outlinedIcon: AiOutlined,
  },
};

export const SUBJECT_ICONS = [
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_english.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_hindi.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_music.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_math.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_science.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_french.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_socialscience.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_generic.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_physicaleducation.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_civics.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_dance.png`,
  `https://cloud.toddleapp.com/s/content/SyioAglTV.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_physics.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_language.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_bio.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_arts.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_chemistry.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_spanish.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_geography.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_mandarin.png`,
  `${getCloudUrl()}/assets/webapp/fm_subject_icns/icon_subjects_history.png`,
];

export const IBIS_GENDER = [
  { label: "M", value: "1", feedLabel: "Male" },
  { label: "F", value: "2", feedLabel: "Female" },
  { label: "X", value: "3", feedLabel: "X" },
];

export const NOTIFICATION_CATEGORY = [
  {
    label: "common:primary",
    value: "PRIMARY",
    userTypes: ["staff", "parent"],
    filterValue: ["PRIMARY", "CLASS_STREAM", "PORTFOLIO"],
    paidOnly: false,
  },
  // primary tab with clubbed filter for student web
  {
    label: "common:primary",
    value: "PRIMARY",
    filterValue: ["PRIMARY", "UPDATES", "CLASS_STREAM", "PORTFOLIO"],
    userTypes: ["student"],
    paidOnly: false,
  },
  {
    label: "common:meetings",
    value: "MEETINGS",
    filterValue: ["MEETINGS"],
    perm: "FeatureFlag:EnableMeetingsTabInNotification",
    userTypes: ["student"],
    paidOnly: false,
  },
  {
    label: "common:updates",
    value: "UPDATES",
    filterValue: ["UPDATES"],
    userTypes: ["staff"],
    paidOnly: false,
  },
  { label: "common:community", value: "COMMUNITY" },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    perm: "Common:Announcement",
    userTypes: ["staff"],
    paidOnly: true,
  },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    perm: "FamilyApp:Announcement",
    userTypes: ["parent"],
    paidOnly: true,
  },
  {
    label: "common:reports",
    value: "REPORTS",
    filterValue: ["REPORTS"],
    perm: "TeacherPortal:ProgressReport",
    userTypes: ["staff"],
    paidOnly: true,
  },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    perm: ["StudentApp:Announcement", "FeatureFlag:StudentAnnouncementTab"],
    userTypes: ["student"],
    paidOnly: true,
  },
];

/*
Permission for the notification tabs are no longer supported,

We show notification tabs based on if the user has recieved any notification for those filtervalues
for example, if user has not recieved any notification on portfolio, we don't show that tab even though the portfolio module is enabled

Primary tab is always shown reagardless if there exist any notification.
*/
export const NOTIFICATION_CATEGORY_V2 = [
  {
    label: "common:primary",
    value: "PRIMARY",
    filterValue: ["PRIMARY", "REPORTS", "UPDATES"],
    userTypes: ["staff"],
    paidOnly: false,
  },
  {
    label: "common:primary",
    value: "PRIMARY",
    filterValue: ["PRIMARY", "UPDATES", "MEETINGS"],
    userTypes: ["student"],
    paidOnly: false,
  },
  {
    label: "common:primary",
    value: "PRIMARY",
    filterValue: ["PRIMARY", "PORTFOLIO", "CLASS_STREAM"],
    userTypes: ["parent"],
    paidOnly: false,
  },
  { label: "common:community", value: "COMMUNITY" },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    userTypes: ["student"],
    paidOnly: true,
  },
  {
    label: "common:assignments",
    value: "CLASS_STREAM",
    filterValue: ["CLASS_STREAM"],
    userTypes: ["student"],
    paidOnly: true,
  },
  {
    label: "teacherHomePage:portfolio",
    value: "PORTFOLIO",
    filterValue: ["PORTFOLIO"],
    userTypes: ["student"],
    paidOnly: true,
  },
  {
    label: "teacherHomePage:portfolio",
    value: "PORTFOLIO",
    filterValue: ["PORTFOLIO"],
    userTypes: ["staff"],
    paidOnly: true,
  },
  {
    label: "common:assignments",
    value: "CLASS_STREAM",
    filterValue: ["CLASS_STREAM"],
    userTypes: ["staff"],
    paidOnly: true,
  },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    userTypes: ["staff"],
    paidOnly: true,
  },
  {
    label: "common:announcement_plural",
    value: "ANNOUNCEMENTS",
    filterValue: ["ANNOUNCEMENTS"],
    userTypes: ["parent"],
    paidOnly: true,
  },
];

export const CURRICULUM_PLANS = [
  { value: "3", label: "Pro Pilot" },
  { value: "2", label: "Pro" },
  { value: "5", label: "Essentials Pilot" },
  { value: "4", label: "Essentials" },
  { value: "8", label: "Ultimate Pilot" },
  { value: "7", label: "Ultimate" },
  { value: "9", label: "Advance Pilot" },
  { value: "10", label: "Advance" },
];

export const CURRICULUM_PILOT_PLANS = [
  { value: "3", label: "Pro Pilot" },
  { value: "5", label: "Essentials Pilot" },
  { value: "8", label: "Ultimate Pilot" },
  { value: "9", label: "Advance Pilot" },
];

export const SUBSCRIPTION_PLANS = [
  { value: "NA", label: "N/A" },
  { value: "FREEMIUM", label: "Freemium" },
  { value: "PRO", label: "Pro" },
  { value: "PRO_AI", label: "Pro+AI" },
  { value: "ESSENTIALS", label: "Essentials" },
  { value: "ULTIMATE", label: "Ultimate" },
];

export const SUBSCRIPTION_STATUS = [
  { value: "PAID", label: "Paid" },
  { value: "PILOT", label: "Pilot" },
  { value: "NON_PAID", label: "Non paid" },
  { value: "DEACTIVATED", label: "Deactivated" },
];

export const CURRICULUM_GROUPS = [
  { value: "IB", label: "IB" },
  { value: "NON_IB", label: "Non-IB" },
];

export const USER_TYPES = [
  { value: "staff", label: "Staff" },
  { value: "student", label: "Student" },
  { value: "parent", label: "Parent" },
];

export const ROLE_TYPES = [
  { value: "admin", label: "Admin" },
  { value: "teacher", label: "Teacher" },
  { value: "reviewer", label: "Reviewer" },
  { value: "visitor", label: "Visitor" },
  { value: "dev_mode", label: "Dev Mode" },
  { value: "parent", label: "Parent" },
  { value: "student", label: "Student" },
];

export const CURRICULUM_PROGRAM_TYPES = [
  { label: "PYP", value: CURRICULUM_TYPE_PYP },
  { label: "MYP", value: CURRICULUM_TYPE_MYP },
  { label: "UbD", value: CURRICULUM_TYPE_UBD },
  { label: "DP", value: CURRICULUM_TYPE_DP },
];

export const PRO_PLAN_IDS = ["2", "3"];

export const CURRICULUM_PLANS_CONSTANTS_MAPPING = {
  PLAN_DEMO: "DEMO",
  PLAN_FREE: "FREE",
  PLAN_PRO_PILOT: "PRO_PILOT",
  PLAN_PRO: "PRO",
  PLAN_360_PILOT: "360_PILOT",
  PLAN_360: "360",
  PLAN_ULTIMATE_PILOT: "ULTIMATE_PILOT",
  PLAN_ULTIMATE: "ULTIMATE",
};

export const CURRICULUM_TYPE_ORDER_MAPPING = {
  [CURRICULUM_TYPE_PYP]: 0,
  [CURRICULUM_TYPE_MYP]: 1,
  [CURRICULUM_TYPE_UBD]: 2,
  [CURRICULUM_TYPE_DP]: 3,
};

export const CURRICULUM_PLAN_ORDER_MAPPING = {
  [PLAN_TYPE_FREE]: 0,
  [PLAN_TYPE_DEMO]: 1,
  [PLAN_TYPE_PRO_PILOT]: 2,
  [PLAN_TYPE_PRO]: 3,
  [PLAN_TYPE_360_PILOT]: 4,
  [PLAN_TYPE_360]: 5,
  [PLAN_TYPE_ULTIMATE_PILOT]: 6,
  [PLAN_TYPE_ULTIMATE]: 7,
};

export const CURRICULUM_PLAN_LABEL_MAPPING_FOR_EXTERNAL_API = {
  [PLAN_TYPE_FREE]: "FREE",
  [PLAN_TYPE_DEMO]: "DEMO",
  [PLAN_TYPE_PRO_PILOT]: "PILOT_PRO",
  [PLAN_TYPE_PRO]: "PRO",
  [PLAN_TYPE_360_PILOT]: "PILOT_360",
  [PLAN_TYPE_360]: "360",
  [PLAN_TYPE_ULTIMATE_PILOT]: "PILOT_ULTIMATE",
  [PLAN_TYPE_ULTIMATE]: "ULTIMATE",
};

export const SUBSCRIPTION_PLANS_LABELS_MAPPING = {
  [CURRICULUM_PLAN_NA]: "N/A",
  [CURRICULUM_PLAN_TYPE_FREEMIUM]: "Freemium",
  [CURRICULUM_PLAN_TYPE_PRO]: "Pro",
  [CURRICULUM_PLAN_TYPE_PRO_AI]: "Pro+AI",
  [CURRICULUM_PLAN_TYPE_ESSENTIALS]: "Essentials",
  [CURRICULUM_PLAN_TYPE_ULTIMATE]: "Ultimate",
};

export const SUBSCRIPTION_STATUS_LABELS_MAPPING = {
  PAID: "Paid",
  PILOT: "Pilot",
  DEACTIVATED: "Deactivated",
  NON_PAID: "Non paid",
};

export const LANGUAGE_OPTIONS = [
  {
    localisedLabel: "common:english",
    label: "English",
    value: "en",
    perm: true,
  },
  {
    localisedLabel: "common:english_us",
    label: "English (US)",
    value: "en-US",
    perm: "FeatureFlag:EnableEnglishVarients",
  },
  {
    localisedLabel: "common:english_uk",
    label: "English (UK)",
    value: "en-GB",
    perm: "FeatureFlag:EnableEnglishVarients",
  },
  {
    localisedLabel: "common:japanese",
    label: "Japanese",
    value: "jpn",
    perm: "FeatureFlag:EnableJapaneseLanguage",
  },
  {
    localisedLabel: "common:spanish",
    label: "Spanish",
    value: "es",
    momentLocale: "es",
    perm: true,
  },
  {
    localisedLabel: "common:turkish",
    label: "Turkish",
    value: "tr",
    momentLocale: "tr",
    perm: true,
  },
  {
    localisedLabel: "common:french",
    label: "French",
    value: "fr",
    momentLocale: "fr",
    perm: true,
  },
  {
    localisedLabel: "common:portuguese",
    label: "Portuguese",
    value: "pt",
    momentLocale: "pt",
    perm: true,
  },
  {
    localisedLabel: "common:chinese",
    label: "Chinese",
    value: "zh",
    momentLocale: "zh-cn",
    perm: true,
  },
  {
    localisedLabel: "common:russian",
    label: "Russian",
    value: "ru",
    momentLocale: "ru",
    perm: "FeatureFlag:EnableRussainLanguage",
  },
  {
    localisedLabel: "common:arabic",
    label: "Arabic",
    value: "ar",
    momentLocale: "ar",
    perm: "FeatureFlag:EnableArabicLanguage",
  },
  // NOTE: When a new language is added here, import the locale in i18n.js
];

export const USER_TYPE_ENTITY_MAPPING = {
  staff: { entityType: "STAFF", type: "Staff" },
  student: { entityType: "STUDENT", type: "Student" },
  parent: { entityType: "FAMILY_MEMBER", type: "Parent" },
  super_admin: { entityType: "STAFF", type: "Staff" },
};

export const DUMMY_USER_INFO = {
  id: "-7",
  email: "public.access@toddleapp.com",
  org_id: "-7",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "COMMUNITY",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_EU_WEST_1 = {
  id: "-8",
  email: "public.platform.access@toddleapp.com",
  org_id: "-8",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_US_EAST_1 = {
  id: "-1073741924",
  email: "public.platform.access.us-east-1@toddleapp.com",
  org_id: "-1073741924",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_AP_SOUTH_EAST_2 = {
  id: "-15",
  email: "public.platform.access.ap-southeast-2@toddleapp.com",
  org_id: "-15",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_AP_SOUTH_EAST_1 = {
  id: "-16",
  email: "public.platform.access.ap-southeast-1@toddleapp.com",
  org_id: "-16",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_ME_CENTRAL_1 = {
  id: "-536870914",
  email: "public.platform.access.me-central-1@toddleapp.com",
  org_id: "-536870914",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const PUBLIC_USER_INFO_EU_CENTRAL_1 = {
  id: "-536870914",
  email: "public.platform.access.me-central-1@toddleapp.com",
  org_id: "-536870914",
  user_type: "staff",
  userEntityType: "STAFF",
  portalType: "PUBLIC",
  enabledMixPanel: true,
};

export const SOCIAL_TYPES = {
  FACEBOOK: "FACEBOOK",
  TWITTER: "TWITTER",
  LINKEDIN: "LINKEDIN",
};

export const DEMO_MYP_ORG = demoMypOrg;

export const UNIT_TYPE_LOCALE = {
  ibInquiry: "common:transdisciplinary",
  ibStandAlone: "common:subject_specific",
  ibMYPSubjectSpecific: "common:subject_specific",
  ibMYPInterdisciplinary: "common:interdisciplinary",
  ubdInquiry: "common:interdisciplinary",
  ubdSubjectSpecific: "common:subject_specific",
  ibDPSubjectSpecific: "common:subject_specific",
};

// "{{type}} unit" was not working for certain languages like portugese
// because it has different translation for each type when suffixed with "unit"
export const UNIT_TYPE_WITH_UNIT_SUFFIX_LOCALES = {
  ibInquiry: "common:transdisciplinary_unit",
  ibStandAlone: "common:subject_specific_unit",
  ibMYPSubjectSpecific: "common:subject_specific_unit",
  ibMYPInterdisciplinary: "common:interdisciplinary_unit",
  ubdInquiry: "common:interdisciplinary_unit",
  ubdSubjectSpecific: "common:subject_specific_unit",
  ibDPSubjectSpecific: "common:subject_specific_unit",
};

export const SUMMARY_EMPTY_STATE_URL = `${getCloudUrl()}/assets/webapp/summary_empty_state.svg`;

export const SIMILARITY_FILE_MIMETYPE = [
  "application/pdf",
  "application/msword",
  "application/vnd.ms-powerpoint",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/postscript",
  "text/rtf",
  "application/rtf",
  "text/html",
  "application/wordperfect",
  "application/vnd.oasis.opendocument.text",
  "text/plain",
  "application/x-hwp",
  "application/vnd.google-apps.presentation",
  "application/vnd.google-apps.spreadsheet",
  "application/vnd.google-apps.document",
];

export const SIMILARITY_ERROR_CODE_MAP = {
  UNSUPPORTED_FILETYPE: "classRoom:unsupported_file_format",
  CANNOT_EXTRACT_TEXT: "classRoom:word_count_less_than_20",
  TOO_LITTLE_TEXT: "classRoom:word_count_less_than_20",
  TOO_MANY_PAGES: "classRoom:file_pages_more_than_800",
  FILE_LOCKED: "classRoom:file_is_password_protected",
  CORRUPT_FILE: "classRoom:corrupt_file",
  ERR_FR_MAX_BODY_LENGTH_EXCEEDED: "classRoom:file_size_more_than_100",
  UNKNOWN_ERROR: "common:unknown_error",
  FAILED_TO_EXPORT: "classRoom:limited_access_or_file_not_found",
  CANNOT_REACH_TURNITIN: "classRoom:cannot_reach_turnitin",
};

export const CURRICULUM_NAME_BY_TYPE = {
  [CURRICULUM_TYPE_DP]: "common:DP",
  [CURRICULUM_TYPE_MYP]: "common:MYP",
  [CURRICULUM_TYPE_UBD]: "common:UBD",
  [CURRICULUM_TYPE_PYP]: "common:PYP",
};

export const FAMILY_INVITE_LANGUAGE_OPTIONS = [
  { label: "Arabic", value: "ar" },
  { label: "English", value: "en" },
  { label: "Kazakh", value: "kaz" },
  { label: "Mandarin", value: "zh" },
  { label: "Spanish", value: "es" },
  { label: "Turkish", value: "tr" },
  { label: "Russian", value: "ru" },
  { label: "Japanese", value: "jpn" },
  {
    label: "Portuguese",
    value: "pt",
  },
  {
    label: "French",
    value: "fr",
  },
];

export const FAMILY_INVITE_PDF_LANGUAGE_OPTIONS_V2 = [
  { label: "English", value: "en" },
  { label: "Mandarin", value: "zh" },
  { label: "Spanish", value: "es" },
  { label: "Turkish", value: "tr" },
  { label: "Japanese", value: "jpn" },
  {
    label: "Portuguese",
    value: "pt",
  },
  {
    label: "French",
    value: "fr",
  },
  { label: "Arabic", value: "ar" },
  { label: "Russian", value: "ru" },
  { label: "Kazakh", value: "kaz" },
];

export const FAMILY_INVITE_EMAIL_LANGUAGE_OPTIONS = [
  { label: "English", value: "EN" },
  { label: "Spanish", value: "ES" },
  { label: "Turkish", value: "TR" },
  { label: "Russian", value: "RU" },
  { label: "Arabic", value: "AR" },
  { label: "Chinese", value: "ZH" },
  { label: "French", value: "FR" },
  { label: "Portuguese", value: "PT" },
  // { label: "Japanese", value: "JPN" },
  // { label: "Turkish", value: "tr" },
  // { label: "Mandarin", value: "mdr" },
];

export const STUDENT_INVITE_LANGUAGE_OPTIONS = [
  { label: "English", value: "en" },
  { label: "Russian", value: "ru" },
];

export const ICONS = {
  AddOutlined: AddOutlined,
  UploadOutlined: UploadOutlined,
  MicrophoneOutlined: MicrophoneOutlined,
  AddCircleOutlined: AddCircleOutlined,
  WorkbookColored: WorkbookColored,
  DeviceDesktopOutlined: DeviceDesktopOutlined,
  GoogleDriveColored: GoogleDriveColored,
  OneDriveColored: OneDriveColored,
  WorksheetClipboardOutlined: WorksheetClipboardOutlined,
  LinkColored: LinkColored,
  LinkOutlined: LinkOutlined,
  WorkbookOutlined: WorkbookOutlined,
  PageFoldPortraitOutlined: PageFoldPortraitOutlined,
  CodeOutlined: CodeOutlined,
};

export const GRAPHQL_ONGOING_QUERY_NETWORK_STATUS = [1, 2];

export const ORGANIZATION_LOGO_PLACEHOLDER_URL = `${getCloudUrl()}/assets/webapp/img_school_logo_placeholder.png`;

export const PAM_AND_TOOLS_CONSTANTS = {
  PlatformAccessManager: {
    isAccessManagerEnabled: "Access Manager",
    isOrganizationsEnabled: "Organizations",
    isManageUsersEnabled: "Manage Users",
  },
  Tools: {
    isTemplateEditorEnabled: "Template Editor",
    isInternalToolsEnabled: "Internal Tools",
    isActivateSchoolsEnabled: "Activate Schools",
  },
};

export const EU_PORTAL_TYPE = "TOOL_EU_WEST_1";
export const US_PORTAL_TYPE = "TOOL_US_EAST_1";
export const ME_PORTAL_TYPE = "TOOL_ME_CENTRAL_1";
export const EU_CENTRAL_PORTAL_TYPE = "TOOL_EU_CENTRAL_1";
export const AU_PORTAL_TYPE = "TOOL_AP_SOUTHEAST_2";
export const SG_PORTAL_TYPE = "TOOL_AP_SOUTHEAST_1";
export const HK_PORTAL_TYPE = "TOOL_AP_EAST_1";
export const CN_PORTAL_TYPE = "TOOL_CN_NORTH_1";

export const PLANNER_ELEMENT_LABEL_MAPPING = {
  PYP_KEY_CONCEPT: "common:concepts_label",
  PYP_LEARNER_PROFILE: "planningInsights:lpa",
  PYP_ATL: "common:atls_label",
  PYP_LEARNING_STANDARD: "common:subject_standard_label",
  PYP_THEME: "common:transdisciplinary_theme_label",
  PYP_RELATED_CONCEPT: "common:related_concepts",
  MYP_KEY_CONCEPT: "common:CONCEPT",
  MYP_RELATED_CONCEPT: "common:related_concepts",
  MYP_SPECIFIED_CONCEPTS: "common:specified_concepts",
  MYP_ATL: "common:atls_label",
  MYP_LEARNING_STANDARD: "common:subject_standard_label",
  MYP_LEARNER_PROFILE: "planningInsights:lpa",
  MYP_OBJECTIVES: "common:myp_objectives",
  MYP_GLOBAL_CONTEXT: "progressReport:global_context",
  DP_SUBJECT_STANDARD: "common:subject_standard_label",
  DP_SYLLABUS: "common:syllabus_content_label",
  DP_AIM: "common:aim_label",
  DP_OBJECTIVES: "common:objectives_label",
  DP_ATL: "common:atl_skills",
  DP_LEARNER_PROFILE: "planningInsights:lpa",
};

export const PLANNER_ELEMENTS_STORED_AS_HTML = [
  "PYP_LEARNING_STANDARD",
  "UBD_LEARNING_STANDARD",
  "MYP_LEARNING_STANDARD",
  "DP_SUBJECT_STANDARD",
  "DP_CRITERIA",
  "DP_ACHIEVEMENT_LEVEL",
];

export const ENTITY_CONFIG_TYPES = {
  CLASS_CONFIGURATION: "class",
  STAFF_CONFIGURATION: "staff",
  STUDENT_CONFIGURATION: "student",
};

export const LIST_POPUP_DIRECTION = {
  LEFT: "left",
  RIGHT: "right",
};
export const MODAL_Z_INDEX = 1100;

export const APOLLO_CACHE_PERSISTENCE_EXPITATION_TIME_DURATION_IN_DAYS = 7;

// this regex allows only numbers with upto 2 decimal points
export const DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX = /^0(\.\d{0,2})?$|^[1-9]\d*(\.\d{0,2})?$/;
// this regex allows only numbers with upto 1 decimal points
export const SINGLE_DIGIT_DECIMAL_NUMBERS_REGEX = /^0(\.\d{0,1})?$|^[1-9]\d*(\.\d{0,1})?$/;
// this regex allows only whole numbers with no decimal points
export const INTEGER_NUMBERS_REGEX = /^[0-9]*$/;

export const SEARCH_INPUT_DEBOUNCE_TIME = 200;

export const GOOGLE_DRIVE_SCOPE = {
  SCOPE_V1: ["https://www.googleapis.com/auth/drive"],
  SCOPE_V2: ["https://www.googleapis.com/auth/drive.file"],
};

export const DATAGRID_AVATAR_COLORS = [
  "violet",
  "blue",
  "yellow",
  "pink",
  "teal",
  "purple",
];

export const SENTRAL_PORTAL_ICON =
  "https://cloud.toddleapp.com/assets/sentralLogo.svg";

export const BLOCKED_FILE_MIME_TYPES = [
  // "application/octet-stream",
  "application/x-sh",
  "application/x-bash",
  "application/x-bat",
  "application/x-msdownload",
  "application/x-makeself",
  "application/x-msdos-program",
  "application/cmd",
  "application/x-cgi",
  "application/java-archive",
  "application/java-vm",
  "application/x-shockwave-flash",
  "application/x-msi",
  "application/exe",
  "application/vnd.appimage",
  "text/php",
  "application/x-httpd-php",
  "application/php",
];

export const BLOCKED_FILE_EXTENSIONS = [
  ".bash",
  ".cmd",
  ".ps1",

  ".sh",
  ".exe",
  ".dll",
  ".com",
  ".bat",
  ".msi",
  ".run",
  ".jar",
  ".war",
  ".ear",
  ".class",
  ".swf",
  ".appimage",

  ".php",
];

//Properties related to user name
export const USER_NAME_PROPERTIES = [
  "firstName",
  "middleName",
  "lastName",
  "preferredName",
  "prefix",
  "suffix",
  "pronouns",
];

export const CURRICULUM_PLAN_ID_MAP = {
  PRO_PILOT: "3",
  PRO: "2",
  ESSENTIALS_PILOT: "5",
  ESSENTIALS: "4",
  ULTIMATE_PILOT: "8",
  ULTIMATE: "7",
  ADVANCE_PILOT: "9",
  ADVANCE: "10",
};
